import { css, cx } from 'linaria';
import { PopupMenuGroup } from '@pocket/web-ui';
import { GridViewIcon } from '@pocket/web-ui';
import { ListViewIcon } from '@pocket/web-ui';
import { DetailViewIcon } from '@pocket/web-ui';
import { buttonReset } from 'components/buttons/button-reset';
import { bottomTooltip } from 'components/tooltip/tooltip';
import { useTranslation } from 'next-i18next';
const listSettingStyle = "ldvpr6d";
export const ListSettings = ({
  listMode = 'grid',
  setListMode,
  setGridMode,
  setDetailMode
}) => {
  const {
    t
  } = useTranslation();

  const isActive = current => current === listMode;

  return <PopupMenuGroup>
      <div className={listSettingStyle}>
        <div className={cx(isActive('list') && 'active')} onClick={setListMode}>
          <button aria-label={t('settings:display-items-as-a-list', 'Display items as a list')} data-tooltip={t('settings:display-items-as-a-list', 'Display items as a list')} data-cy="display-list" className={cx(buttonReset, bottomTooltip, 'backing')}>
            <ListViewIcon />
          </button>
        </div>
        <div className={cx(isActive('detail') && 'active')} onClick={setDetailMode}>
          <button aria-label={t('settings:display-items-in-detail', 'Display items in detail')} data-tooltip={t('settings:display-items-in-detail', 'Display items in detail')} data-cy="display-detail" className={cx(buttonReset, bottomTooltip, 'backing')}>
            <DetailViewIcon />
          </button>
        </div>
        <div className={cx(isActive('grid') && 'active')} onClick={setGridMode}>
          <button aria-label={t('settings:display-items-as-a-grid', 'Display items as a grid')} data-tooltip={t('settings:display-items-as-a-grid', 'Display items as a grid')} data-cy="display-grid" className={cx(buttonReset, bottomTooltip, 'backing')}>
            <GridViewIcon />
          </button>
        </div>
      </div>
    </PopupMenuGroup>;
};

require("../../../.linaria-cache/src/components/display-settings/list-modes.linaria.module.css");